import { Modal } from "antd";
import React from "react";
import Button from "./Button.tsx";
import { CloseOutlined } from "@ant-design/icons";

interface CenterModalProps {
  btnLabel?: string;
  width?: number;
  title: string;
  isOpen: boolean;
  setOpen?: (open: boolean) => void;
  children: React.ReactNode;
  onSubmit: () => void;
  onCancel: () => void;
  submitLabel: string;
  slideOpenButton?: boolean;
  cancelLabel?: string;
  cancelClassName?: string;
  disabled?: boolean;
  btnClassName?: string;
}

const CenterModal = ({ width = 800, title, btnLabel, isOpen, setOpen, children, onSubmit, onCancel, submitLabel, slideOpenButton, cancelLabel = "Cancel", cancelClassName, disabled, btnClassName }: CenterModalProps) => {
  return (
    <>
      <Modal
        title={title}
        open={isOpen}
        onCancel={onCancel}
        width={width}
        closeIcon={<CloseOutlined className="w-[14px] h-[14px] text-[#828282] hover:text-gray-700 cursor-pointer" />}
        maskClosable={false}
        keyboard={false}
        bodyStyle={{ maxHeight: 'calc(100vh - 200px)', overflow: 'auto' }}
        style={{ top: 20 }}
        footer={
          <div className="flex justify-end items-center gap-[16px] mt-4">
            <Button
              label={cancelLabel}
              type="button"
              onClick={onCancel}
              className={
                cancelClassName ||
                "px-4 py-2 w-[86px] h-[36px] text-[#454545] bg-[#FFFFFF] border border-[#D0D5DD] hover:bg-[#F2F2F2] transition-all duration-300"
              } />
            <Button
              label={submitLabel}
              type="button"
              onClick={(event) => {
                event.preventDefault(); 
                onSubmit(); 
              }}
              className="px-4 py-2 w-[86px] h-[36px] text-[#FCFCFC] bg-[#222222] hover:bg-[#3A3A3A] transition-all duration-300"
            />
          </div>
        }
      >
        {children}
      </Modal>
    </>
  );
};

export default CenterModal;
